<template>
  <vs-card>
    <div class="vx-row mb-4">
      <div class="vx-col sm:w-2/12 w-full">
        <label for="Tipo" class="vs-select--label">Tipo</label>
        <v-select
          :options="LIST_PESSOAS"
          name="Tipo"
          label="label"
          id="Tipo"
          v-model="form.tipo"
          @input="emitChangedForm('tipo', form.tipo)"
          class="select-large w-full"
          :state="validateState('Tipo')"
          :danger="validateClass('Tipo')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-4/12 w-full">
        <vs-input
          class="w-full"
          :label="labelNome()"
          v-model="form.nome"
          name="Nome"
          id="nome"
          @change="emitChangedForm('nome', form.nome)"
          :state="validateState('Nome')"
          :danger="validateClass('Nome')"
        />
      </div>

      <div
        v-if="form.tipo == 'Pessoa Física'"
        class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
      >
        <vs-checkbox
          v-model="form.nomeSocial"
          @change="emitChangedForm('nomeSocial', form.nomeSocial)"
        >
          Nome Social?
        </vs-checkbox>
      </div>

      <div v-if="form.nomeSocial" class="vx-col w-full sm:w-4/12">
        <vs-input
          class="w-full"
          label="Nome Civil"
          v-model="form.nomeCivil"
          name="Nome Civil"
          id="Nome Civil"
          v-validate="{ required: true }"
          @change="emitChangedForm('nomeCivil', form.nomeCivil)"
          :state="validateState('Nome Civil')"
          :danger="validateClass('Nome Civil')"
        />
      </div>
    </div>
    <div class="vx-row" v-if="form.tipo == 'Pessoa Física'">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="CPF"
          v-mask="DOCUMENT_MASK.CPF_ONLY"
          v-model="cpf"
          name="CPF"
          @change="emitChangedForm('cpfcnpj', form.cpfcnpj)"
          v-validate="{ min: 14 }"
          :state="validateState('CPF')"
          :danger="validateClass('CPF')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="RG"
          v-model="form.rgIe"
          name="RG"
          @change="emitChangedForm('rgIe', form.rgIe)"
          :state="validateState('RG')"
          :danger="validateClass('RG')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Nascimento"
          v-mask="'##/##/####'"
          v-model="form.dataNascimento"
          name="Data de Nascimento"
          @change="emitChangedForm('dataNascimento', form.dataNascimento)"
          v-validate="{ date_format: 'dd/MM/yyyy' }"
          :state="validateState('Data de Nascimento')"
          :danger="validateClass('Data de Nascimento')"
        />
      </div>
    </div>
    <div class="vx-row" v-if="form.tipo == 'Pessoa Jurídica'">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNPJ"
          @input="cpf = $event.toUpperCase()"
          v-model="cpf"
          name="CNPJ"
          @change="emitChangedForm('cpfcnpj', form.cpfcnpj)"
          v-validate.immediate="{ min: 18 }"
          :state="validateState('CNPJ')"
          :danger="validateClass('CNPJ')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Inscrição Estadual"
          v-model="form.rgIe"
          name="Inscrição Estadual"
          @change="emitChangedForm('rgIe', form.rgIe)"
          :state="validateState('Inscrição Estadual')"
          :danger="validateClass('Inscrição Estadual')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Representante Legal"
          v-model="form.representanteLegal"
          name="Nome Completo Represente Legal"
          @change="
            emitChangedForm('representanteLegal', form.representanteLegal)
          "
          :state="validateState('Nome Completo Represente Legal')"
          :danger="validateClass('Nome Completo Represente Legal')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Cpf do Representante"
          v-mask="DOCUMENT_MASK.CPF_ONLY"
          v-model="form.cpfRepresentante"
          name="Cpf do Representante"
          @change="emitChangedForm('cpfRepresentante', form.cpfRepresentante)"
          v-validate="{ min: 14 }"
          :state="validateState('Cpf do Representante')"
          :danger="validateClass('Cpf do Representante')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Email"
          v-model="form.email"
          name="Email"
          id="email"
          @change="emitChangedForm('email', form.email)"
          v-validate="{ email: true }"
          :state="validateState('Email')"
          :danger="validateClass('Email')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="Celular" class="vs-select--label">Celular</label>
        <the-mask
          mask="(##) #####-####"
          id="Celular"
          class="vs-inputx vs-input--input normal hasValue w-full"
          v-model="form.celular"
          name="Celular"
          :masked="true"
          v-validate="{ required: true, min: 15 }"
          @blur.native="emitChangedForm('celular', form.celular)"
          :state="validateState('Celular')"
          :danger="validateClass('Celular')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Telefone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          v-model="form.telefone"
          name="Telefone"
          id="telefone"
          @change="emitChangedForm('telefone', form.telefone)"
        />
      </div>
    </div>
    <div v-if="form.tipo === LIST_PESSOAS[0]" class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="Tipo de CNH" class="vs-select--label">Sexo</label>
        <v-select
          name="Sexo"
          label="label"
          id="Sexo"
          :state="validateState('Sexo')"
          :danger="validateClass('Sexo')"
          v-model="form.sexo"
          :options="LIST_SEXO"
          @input="emitChangedForm('sexo', form.sexo)"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="Estado Civil" class="vs-select--label">Estado Civil</label>
        <v-select
          name="Estado Civil"
          label="label"
          id="Estado Civil"
          :state="validateState('Estado Civil')"
          :danger="validateClass('Estado Civil')"
          v-model="form.estadoCivil"
          :options="LIST_ESTADO_CIVIL"
          @input="emitChangedForm('estadoCivil', form.estadoCivil)"
        ></v-select>
      </div>
      <div
        v-if="form.estadoCivil === CASADO"
        class="vx-col sm:w-1/3 w-full mb-2"
      >
        <label for="Regime Casamento" class="vs-select--label"
          >Regime Casamento</label
        >
        <v-select
          name="Regime Casamento"
          label="label"
          id="Regime Casamento"
          :state="validateState('Regime Casamento')"
          :danger="validateClass('Regime Casamento')"
          v-model="form.regimeCasamento"
          :options="LIST_REGIME_CASAMENTO"
          @input="emitChangedForm('regimeCasamento', form.regimeCasamento)"
        ></v-select>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Possui CNH?</label>
        <vs-switch
          color="success"
          v-model.number="possuiCnh"
          id="isZero"
          @input="sanitizeDataCnh()"
        >
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>
      <div v-if="possuiCnh" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNH"
          v-mask="'###########'"
          v-model="form.cnh"
          name="CNH"
          id="cnh"
          @change="emitChangedForm('cnh', form.cnh)"
          v-validate="{ min: 11 }"
          :state="validateState('CNH')"
          :danger="validateClass('CNH')"
        />
      </div>
      <div v-if="possuiCnh" class="vx-col sm:w-1/4 w-full mb-2">
        <label for="Tipo de CNH" class="vs-select--label">Tipo de CNH</label>
        <v-select
          :options="LIST_CNH"
          name="Tipo de CNH"
          label="label"
          id="Tipo de CNH"
          v-model="form.catCnh"
          @input="emitChangedForm('catCnh', form.catCnh)"
          class="select-large w-full"
          :state="validateState('Tipo de CNH')"
          :danger="validateClass('Tipo de CNH')"
        ></v-select>
      </div>
      <div v-if="possuiCnh" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Vencimento CNH"
          v-mask="'##/##/####'"
          v-model="form.dataVencimentoCnh"
          name="Data de Vencimento CNH"
          id="dataVencimentoCnh"
          @change="emitChangedForm('dataVencimentoCnh', form.dataVencimentoCnh)"
        />
      </div>
    </div>
    <!-- endereço -->
    <h5 class="mt-6">Endereço</h5>
    <hr class="mt-2 mb-3 hr-endereco" />

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CEP"
          v-mask="'##.###-###'"
          v-model="form.cep"
          name="CEP"
          @keyup.native="keymonitor"
          id="cep"
          @change="emitChangedForm('cep', form.cep)"
          v-validate="{ required: true, min: 10 }"
          :state="validateState('CEP')"
          :danger="validateClass('CEP')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Endereço"
          v-model="form.endereco"
          name="Endereço"
          id="endereco"
          @change="emitChangedForm('endereco', form.endereco)"
          v-validate="{ required: true }"
          :state="validateState('Endereço')"
          :danger="validateClass('Endereço')"
        />
      </div>
      <div class="vx-col sm:w-1/6 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número"
          v-model="form.numero"
          name="Número"
          id="numero"
          @change="emitChangedForm('numero', form.numero)"
          v-validate="{ required: true }"
          :state="validateState('Número')"
          :danger="validateClass('Número')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Complemento"
          v-model="form.complemento"
          name="Complemento"
          id="complemento"
          @change="emitChangedForm('complemento', form.complemento)"
          v-validate="{ required: false }"
          :state="validateState('Complemento')"
          :danger="validateClass('Complemento')"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Bairro"
          v-model="form.bairro"
          name="Bairro"
          id="bairro"
          @change="emitChangedForm('bairro', form.bairro)"
          v-validate="{ required: true }"
          :state="validateState('Bairro')"
          :danger="validateClass('Bairro')"
        />
      </div>

      <div
        v-if="usaUF || isInterno"
        :class="`vx-col ${isInterno ? 'sm:w-1/3' : 'sm:w-1/2'} w-1/2 mb-2`"
      >
        <label for="" class="vs-select--label">Estado</label>
        <v-select
          :options="estados"
          name="Estado"
          id="Estado"
          autocomplete="off"
          @input="
            ((abrirSelectCidade = true), (alterouEstado = true)),
              buscaDadosSelectsCidades(
                'domMunicipio',
                'cidades',
                'nomeCidade',
                'idCidade',
              ),
              selecionaEstado()
          "
          v-model="estado"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Estado')"
          :class="validateClass('Estado')"
        ></v-select>
      </div>

      <div
        v-if="usaUF || isInterno"
        :class="`vx-col ${
          isInterno == true ? 'sm:w-1/3' : 'sm:w-2/2'
        } w-1/2 mb-2`"
      >
        <label for="" class="vs-select--label">Cidade</label>
        <v-select
          :options="cidades"
          name="Cidade"
          id="Cidade"
          @input="selecionaCidade()"
          ref="selectCidade"
          v-model="cidade"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Cidade')"
          :class="validateClass('Cidade')"
        ></v-select>
      </div>
    </div>
  </vs-card>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import vSelect from 'vue-select';
import {
  LIST_CNH,
  LIST_PESSOAS,
  LIST_SEXO,
  LIST_ESTADO_CIVIL,
  LIST_REGIME_CASAMENTO,
  CASADO,
} from '../../utils/constants';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: ['dadosProposta', 'formulario', 'regionais'],
  watch: {
    dadosProposta() {
      this.preencheForm();
    },
    estado(newvalue, oldvalue) {
      if (this.form.cep) {
        return;
      }

      if (newvalue != oldvalue && oldvalue != null) {
        this.cidade = null;
        this.form.cidade = null;

        this.resetEndereco(newvalue, oldvalue);
      }
    },
    cidade(newValue, oldValue) {
      if (
        newValue != oldValue &&
        oldValue != null &&
        typeof oldValue == 'string'
      ) {
        this.resetEndereco(newValue, oldValue);
      }
    },
  },
  components: { 'v-select': vSelect },
  data() {
    const possuiCnh = 1;
    return {
      DOCUMENT_MASK,
      LIST_PESSOAS,
      LIST_CNH,
      LIST_SEXO,
      LIST_ESTADO_CIVIL,
      LIST_REGIME_CASAMENTO,
      CASADO,
      possuiCnh,
      form: {
        idProposta: null,
        idProspect: null,
        tipo: null,
        nome: null,
        nomeSocial: null,
        nomeCivil: null,
        email: null,
        cpfcnpj: null,
        rgIe: null,
        dataNascimento: null,
        representanteLegal: null,
        cpfRepresentante: null,
        idRegional: null,
        telefone: null,
        celular: null,
        sexo: null,
        estadoCivil: null,
        regimeCasamento: null,
        naoPossuiCnh: !possuiCnh,
        cnh: null,
        catCnh: null,
        dataVencimentoCnh: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        cpfDuplicado: false,
        unificaAssociado: false,
      },
      cpf: null,
      formVerificaCpf: {},
      usaUF: true,
      isInterno: true,
      estado: null,
      cidade: null,
      estados: [],
      cidades: [],
      abrirSelectCidade: false,
      finalizouBuscaCep: false,
      alterouEstado: false,
    };
  },
  methods: {
    resetEndereco(novoValorEstado, valorAntigoEstado) {
      if (
        this.finalizouBuscaCep &&
        novoValorEstado != valorAntigoEstado.label &&
        this.alterouEstado == false
      ) {
        return;
      }

      this.form.cep = null;
      this.emitChangedForm('cep', this.form.cep);

      this.emitChangedForm('cep', this.form.cidade);
      this.form.endereco = null;
      this.emitChangedForm('endereco', this.form.endereco);
      this.form.bairro = null;
      this.emitChangedForm('bairro', this.form.bairro);
      this.form.numero = null;
      this.emitChangedForm('numero', this.form.numero);
      this.form.complemento = null;
      this.emitChangedForm('complemento', this.form.complemento);

      document.querySelector('#cep').focus();
      this.finalizouBuscaCep = false;
      return;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');

        this.$vs.loading();
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.form.endereco = res.data.street;
            this.emitChangedForm('endereco', this.form.endereco);
            this.form.bairro = res.data.neighborhood;
            this.emitChangedForm('bairro', this.form.bairro);

            if (
              res.data.state != this.form.estado ||
              res.data.city != this.form.cidade
            ) {
              this.estado = res.data.state;
              this.form.estado = res.data.state;

              this.emitChangedForm('estado', this.form.estado);

              this.form.cidade = res.data.city;
              this.cidade = res.data.city;

              this.emitChangedForm('cidade', this.form.cidade);
            }

            this.finalizouBuscaCep = true;
            this.temCep = true;

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      if (this.formulario.dadosCliente.idProposta) {
        this.form = this.formulario.dadosCliente;
        this.cpf = this.formulario.dadosCliente.cpfcnpj;
      } else {
        if (this.dadosProposta.idProposta) {
          this.form.idProposta = this.dadosProposta.idProposta;
          this.form.idProspect = this.dadosProposta.dadosCliente.idProspect;
          this.form.tipo = this.dadosProposta.dadosCliente.tipo;
          this.form.nome = this.dadosProposta.dadosCliente.associado;
          this.form.nomeSocial =
            this.dadosProposta.dadosCliente.associadoNomeSocial;
          this.form.nomeCivil =
            this.dadosProposta.dadosCliente.associadoNomeCivil;
          this.form.email = this.dadosProposta.dadosCliente.email;
          this.cpf = this.dadosProposta.dadosCliente.cpf;
          this.form.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
          this.form.dataNascimento =
            this.dadosProposta.dadosCliente.dataNascimento;
          this.form.rgIe = this.dadosProposta.dadosCliente.rg_ie;
          this.form.cnh = this.dadosProposta.dadosCliente.cnh;
          this.form.catCnh = this.dadosProposta.dadosCliente.catCnh;
          this.form.dataVencimentoCnh =
            this.dadosProposta.dadosCliente.dataVencimentoCnh;
          this.form.representanteLegal =
            this.dadosProposta.dadosCliente.representanteLegal;
          this.form.cpfRepresentante =
            this.dadosProposta.dadosCliente.cpfRepresentante;
          this.form.idRegional = this.dadosProposta.dadosCliente.idRegional;
          this.form.telefone = this.dadosProposta.dadosCliente.telefone;
          this.form.celular =
            this.dadosProposta.dadosCliente.celular == null
              ? this.dadosProposta.dadosCliente.telefone
              : this.dadosProposta.dadosCliente.celular;
          this.form.naoPossuiCnh = this.dadosProposta.dadosCliente.naoPossuiCnh;
          this.possuiCnh = !this.dadosProposta.dadosCliente.naoPossuiCnh;
          this.form.sexo = this.dadosProposta.dadosCliente.sexo;
          this.form.estadoCivil = this.dadosProposta.dadosCliente.estadoCivil;
          this.form.regimeCasamento =
            this.dadosProposta.dadosCliente.regimeCasamento;

          this.form.cep = this.dadosProposta.dadosCliente.cep;
          this.temCep = this.dadosProposta.dadosCliente.cep ? true : false;

          this.form.endereco = this.dadosProposta.dadosCliente.endereco;
          this.form.numero = this.dadosProposta.dadosCliente.numero;
          this.form.complemento = this.dadosProposta.dadosCliente.complemento;
          this.form.bairro = this.dadosProposta.dadosCliente.bairro;

          this.cidade = this.dadosProposta.dadosCliente.cidade;
          this.form.cidade = this.dadosProposta.dadosCliente.cidade;

          if (
            this.dadosProposta.dadosCliente.estado &&
            this.dadosProposta.dadosCliente.estado.length == 2
          ) {
            const objEstado = this.estados.find(
              (estado) =>
                estado.label === this.dadosProposta.dadosCliente.estado,
            );

            this.estado = { id: objEstado.id, label: objEstado.label };
            this.form.estado = objEstado.label;

            this.buscaDadosSelectsCidades(
              'domMunicipio',
              'cidades',
              'nomeCidade',
              'idCidade',
            );
          }
        }
      }

      this.emitLoadedForm();
    },
    emitLoadedForm() {
      this.$emit('loaded', { formulario: 'dadosCliente', ...this.form });
      this.$validator.validateAll();
    },
    async emitChangedForm(id, value) {
      this.$validator.validateAll();
      this.$emit('changed', {
        formulario: 'dadosCliente',
        id,
        value,
      });
    },
    limparCpf() {
      this.cpf = null;
      this.form.cpfDuplicado = false;
    },
    selecionaEstado() {
      if (!this.estado) {
        this.cidade = null;
        return;
      }

      // const aux = this.estados.find((x) => x.id == this.estado.id);
      // this.form.estado = aux.label;

      this.form.estado = this.estado.label;
      if (this.estado.id && !this.cidade.id) {
        this.emitChangedForm('estado', this.form.estado);
      }
    },

    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      // const aux = this.cidades.find((x) => x.id == this.form.cidade.id);
      // this.form.cidade = aux.label;

      this.form.cidade = this.cidade.label;
      this.emitChangedForm('cidade', this.form.cidade);
    },

    buscaDadosSelectsEstados(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort((a, b) => {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado || this.estado.label === 'EX' || !this.estado.id) {
        this[array] = [];
        this.cidade = null;
        this.$refs.selectCidade.open = false;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then(({ data }) => {
            if (data)
              data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });

        if (this.abrirSelectCidade) {
          this.$refs.selectCidade.open = true;
          this.abrirSelectCidade = false;
        }
      }
    },
    sanitizeDataCnh() {
      if (!this.possuiCnh) {
        this.cnh = null;
        this.catCnh = null;
        this.dataVencimentoCnh = null;

        this.emitChangedForm('cnh', this.cnh);
        this.emitChangedForm('catCnh', this.catCnh);
        this.emitChangedForm('dataVencimentoCnh', this.dataVencimentoCnh);
      }

      this.emitChangedForm('naoPossuiCnh', !this.possuiCnh);
    },
    labelNome() {
      return this.form.tipo == 'Pessoa Física'
        ? 'Nome Completo/Nome Social'
        : 'Nome';
    },
  },

  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaDadosSelectsEstados('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaDadosSelectsCidades(
      'domMunicipio',
      'cidades',
      'nomeCidade',
      'idCidade',
    );
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}

hr.hr-endereco {
  color: grey;
  opacity: 0.4;
}

.checkBoxNomeSocial {
  align-self: center;
}
</style>
